import { useCallback, useEffect, useState } from 'react';
import PackagesApi from '../api/paquetes';

const useAvailableDates = (originId, destinationId) => {
  const [availableDates, setAvailableDates] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const normalizeId = useCallback((id) => {
    if (Array.isArray(id)) {
      return id.join(',');
    }
    return String(id);
  }, []);

  const fetchAvailableDates = useCallback(
    async (forceRefresh = false) => {
      if (!originId || !destinationId) {
        setIsLoading(false);
        setError(null);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const normalizedOriginId = normalizeId(originId);
        const normalizedDestinationId = normalizeId(destinationId);

        const response = await PackagesApi.getAvailableDates({
          originId: normalizedOriginId,
          destinationId: normalizedDestinationId,
        });

        setAvailableDates(response?.availableDates ?? null);
      } catch (err) {
        console.error('Error fetching available dates:', err);
        setError(err.message || 'Error al obtener las fechas disponibles');
        setAvailableDates(null);
      } finally {
        setIsLoading(false);
      }
    },
    [originId, destinationId, normalizeId]
  );

  useEffect(() => {
    fetchAvailableDates();
  }, [fetchAvailableDates]);

  const refreshAvailableDates = useCallback(() => {
    fetchAvailableDates(true);
  }, [fetchAvailableDates]);

  const clearAvailableDates = useCallback(() => {
    setAvailableDates(null);
    setError(null);
    setIsLoading(false);
  }, []);

  return {
    availableDates,
    isLoading,
    error,
    refreshAvailableDates,
    clearAvailableDates,
  };
};

export default useAvailableDates;
